const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function printBatchPickSlip(doNumber, lines) {
  const now = new Date().toLocaleString();
  const totalPallets = lines.reduce((sum, l) => sum + (parseInt(l.pallets) || 0), 0);
  const totalCartons = lines.reduce((sum, l) => sum + ((parseInt(l.pallets) || 0) * (parseInt(l.cartons) || 0)), 0);
  const uniqueLocations = [...new Set(lines.map(l => l.location_code).filter(Boolean))];

  const rows = lines.map((l, i) => `
    <tr>
      <td class="idx">${i + 1}</td>
      <td class="mono bold">${l.item_code || '-'}</td>
      <td class="mono">${l.qc_number || '-'}</td>
      <td class="mono">${l.batch_number || '-'}</td>
      <td class="mono bold loc">${l.location_code || 'TBD'}</td>
      <td class="mono qty">${l.pallets} plts${l.cartons ? ` × ${l.cartons} ctns` : ''}</td>
      <td class="check-box"></td>
    </tr>
  `).join('');

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>D/O Picking Document - ${doNumber}</title>
      <style>
        @page { size: A4 portrait; margin: 12mm; }
        * { box-sizing: border-box; }
        body { font-family: 'Helvetica', Arial, sans-serif; margin: 0; padding: 16px; color: #000; font-size: 11px; }
        .header { border-bottom: 3px solid #000; padding-bottom: 12px; margin-bottom: 14px; display: flex; justify-content: space-between; align-items: flex-start; }
        .title-block h1 { font-size: 22px; font-weight: 900; letter-spacing: 1px; margin: 0; }
        .title-block .sub { font-size: 10px; color: #444; margin-top: 4px; }
        .do-box { border: 3px solid #000; padding: 8px 16px; text-align: center; background: #f0f0f0; }
        .do-label { font-size: 9px; letter-spacing: 2px; margin: 0; }
        .do-num { font-size: 22px; font-weight: 900; letter-spacing: 2px; margin: 2px 0 0; }
        .summary { display: flex; gap: 20px; padding: 8px 12px; background: #f8f8f8; border-left: 4px solid #000; margin-bottom: 12px; font-size: 10px; }
        .summary strong { font-size: 13px; }
        table { width: 100%; border-collapse: collapse; font-size: 10px; }
        th, td { padding: 8px; border: 1px solid #666; text-align: left; vertical-align: top; }
        th { background: #000; color: #fff; font-size: 9px; text-transform: uppercase; letter-spacing: 0.5px; }
        .mono { font-family: 'Courier New', monospace; }
        .bold { font-weight: 700; }
        .idx { text-align: center; width: 30px; }
        .loc { color: #007AFF; font-size: 12px; }
        .qty { font-weight: 700; }
        .check-box { width: 40px; height: 24px; }
        .signature { margin-top: 30px; display: flex; justify-content: space-between; gap: 40px; page-break-inside: avoid; }
        .sig { flex: 1; }
        .sig-line { border-top: 1px solid #000; margin-top: 35px; padding-top: 4px; font-size: 9px; }
        .footer { margin-top: 20px; display: flex; justify-content: space-between; font-size: 8px; color: #666; border-top: 1px solid #ccc; padding-top: 6px; }
        @media print { body { padding: 0; } .no-print { display: none; } }
        tbody tr { page-break-inside: avoid; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="title-block">
          <h1>D/O PICKING DOCUMENT</h1>
          <div class="sub">Warehouse Management System • Printed: ${now}</div>
        </div>
        <div class="do-box">
          <p class="do-label">D/O NUMBER</p>
          <p class="do-num">${doNumber}</p>
        </div>
      </div>

      <div class="summary">
        <span>Line Items: <strong>${lines.length}</strong></span>
        <span>Total Pallets: <strong>${totalPallets}</strong></span>
        <span>Total Cartons: <strong>${totalCartons}</strong></span>
        <span>Locations: <strong>${uniqueLocations.length}</strong></span>
      </div>

      <table>
        <thead>
          <tr>
            <th class="idx">#</th>
            <th>Item Code</th>
            <th>QC / Shade</th>
            <th>Batch Number</th>
            <th>Pick Location</th>
            <th>Quantity</th>
            <th>Picked ✓</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>

      <div class="signature">
        <div class="sig"><div class="sig-line">Forklift Driver (Name & Signature)</div></div>
        <div class="sig"><div class="sig-line">Warehouse Supervisor</div></div>
        <div class="sig"><div class="sig-line">Date & Time Completed</div></div>
      </div>

      <div class="footer">
        <span>D/O ${doNumber} • Multi-Item Pick Document</span>
        <span>WMS © ${new Date().getFullYear()}</span>
      </div>

      <div class="no-print" style="margin-top: 16px; text-align: center;">
        <button onclick="window.print()" style="padding: 10px 24px; font-size: 14px; cursor: pointer;">Print Now</button>
        <button onclick="window.close()" style="padding: 10px 24px; font-size: 14px; margin-left: 10px; cursor: pointer;">Close</button>
      </div>
    </body>
    </html>
  `;

  const printWin = window.open('', '_blank', 'width=1000,height=800');
  if (!printWin) {
    alert('Please allow pop-ups to print the D/O document');
    return;
  }
  printWin.document.write(html);
  printWin.document.close();
  setTimeout(() => { printWin.print(); }, 400);
}

export function printReplenishmentSlip(slipNo, tasks) {
  const now = new Date().toLocaleString();
  const totalPallets = tasks.reduce((sum, t) => sum + (parseInt(t.pallets) || 0), 0);
  const uniqueFrom = [...new Set(tasks.map(t => t.from_location_code).filter(Boolean))];
  const uniqueTo = [...new Set(tasks.map(t => t.to_location_code).filter(Boolean))];

  const rows = tasks.map((t, i) => `
    <tr>
      <td class="idx">${i + 1}</td>
      <td class="mono bold">${t.item_code || '-'}</td>
      <td class="mono">${t.qc_number || '-'}</td>
      <td class="mono">${t.batch_number || '-'}</td>
      <td class="mono bold from">${t.from_location_code || 'TBD'}</td>
      <td class="mono bold to">${t.to_location_code || 'TBD'}</td>
      <td class="mono qty">${t.pallets} plts${t.cartons ? ` × ${t.cartons} ctns` : ''}</td>
      <td class="prio ${(t.priority || 'normal')}">${(t.priority || 'normal').toUpperCase()}</td>
      <td class="check-box"></td>
    </tr>
  `).join('');

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Replenishment Instructions - ${slipNo}</title>
      <style>
        @page { size: A4 portrait; margin: 12mm; }
        * { box-sizing: border-box; }
        body { font-family: 'Helvetica', Arial, sans-serif; margin: 0; padding: 16px; color: #000; font-size: 11px; }
        .header { border-bottom: 3px solid #000; padding-bottom: 12px; margin-bottom: 14px; display: flex; justify-content: space-between; align-items: flex-start; }
        .title-block h1 { font-size: 22px; font-weight: 900; letter-spacing: 1px; margin: 0; color: #DC2626; }
        .title-block .sub { font-size: 10px; color: #444; margin-top: 4px; }
        .no-box { border: 3px solid #000; padding: 8px 16px; text-align: center; background: #FEF2F2; }
        .no-label { font-size: 9px; letter-spacing: 2px; margin: 0; }
        .no-num { font-size: 18px; font-weight: 900; letter-spacing: 1px; margin: 2px 0 0; }
        .summary { display: flex; gap: 20px; padding: 8px 12px; background: #f8f8f8; border-left: 4px solid #DC2626; margin-bottom: 12px; font-size: 10px; }
        .summary strong { font-size: 13px; }
        table { width: 100%; border-collapse: collapse; font-size: 10px; }
        th, td { padding: 8px; border: 1px solid #666; text-align: left; vertical-align: top; }
        th { background: #000; color: #fff; font-size: 9px; text-transform: uppercase; letter-spacing: 0.5px; }
        .mono { font-family: 'Courier New', monospace; }
        .bold { font-weight: 700; }
        .idx { text-align: center; width: 28px; }
        .from { color: #F59E0B; font-size: 12px; }
        .to { color: #16A34A; font-size: 12px; }
        .qty { font-weight: 700; }
        .prio { font-weight: 700; font-size: 9px; text-align: center; }
        .prio.high { background: #DC2626; color: #fff; }
        .check-box { width: 32px; height: 22px; }
        .signature { margin-top: 30px; display: flex; justify-content: space-between; gap: 40px; page-break-inside: avoid; }
        .sig { flex: 1; }
        .sig-line { border-top: 1px solid #000; margin-top: 35px; padding-top: 4px; font-size: 9px; }
        .footer { margin-top: 20px; display: flex; justify-content: space-between; font-size: 8px; color: #666; border-top: 1px solid #ccc; padding-top: 6px; }
        @media print { body { padding: 0; } .no-print { display: none; } }
        tbody tr { page-break-inside: avoid; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="title-block">
          <h1>REPLENISHMENT INSTRUCTION</h1>
          <div class="sub">Move stock from source to picking zones • Printed: ${now}</div>
        </div>
        <div class="no-box">
          <p class="no-label">SLIP NO</p>
          <p class="no-num">${slipNo}</p>
        </div>
      </div>

      <div class="summary">
        <span>Movements: <strong>${tasks.length}</strong></span>
        <span>Total Pallets: <strong>${totalPallets}</strong></span>
        <span>From Locations: <strong>${uniqueFrom.length}</strong></span>
        <span>To Locations: <strong>${uniqueTo.length}</strong></span>
      </div>

      <table>
        <thead>
          <tr>
            <th class="idx">#</th>
            <th>Item Code</th>
            <th>QC / Shade</th>
            <th>Batch</th>
            <th>FROM (pick from)</th>
            <th>TO (put at)</th>
            <th>Quantity</th>
            <th>Priority</th>
            <th>Done ✓</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>

      <div class="signature">
        <div class="sig"><div class="sig-line">Forklift Driver (Name & Signature)</div></div>
        <div class="sig"><div class="sig-line">Warehouse Supervisor</div></div>
        <div class="sig"><div class="sig-line">Date & Time Completed</div></div>
      </div>

      <div class="footer">
        <span>Slip ${slipNo} • Auto-generated Replenishment Instructions</span>
        <span>WMS © ${new Date().getFullYear()}</span>
      </div>

      <div class="no-print" style="margin-top: 16px; text-align: center;">
        <button onclick="window.print()" style="padding: 10px 24px; font-size: 14px; cursor: pointer;">Print Now</button>
        <button onclick="window.close()" style="padding: 10px 24px; font-size: 14px; margin-left: 10px; cursor: pointer;">Close</button>
      </div>
    </body>
    </html>
  `;

  const printWin = window.open('', '_blank', 'width=1000,height=800');
  if (!printWin) {
    alert('Please allow pop-ups to print the replenishment slip');
    return;
  }
  printWin.document.write(html);
  printWin.document.close();
  setTimeout(() => { printWin.print(); }, 400);
}

export function printMovementSlip(taskType, data) {
  const title = taskType === 'putaway' ? 'PUT AWAY INSTRUCTION' : 'PICKING INSTRUCTION';
  const locLabel = taskType === 'putaway' ? 'PUT AT LOCATION' : 'PICK FROM LOCATION';
  const locCode = taskType === 'putaway' ? (data.to_location_code || data.location_code) : (data.from_location_code || data.location_code);
  const now = new Date().toLocaleString();
  const cartonInfo = data.cartons ? ` × ${data.cartons} ctns` : '';

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>${title}</title>
      <style>
        @page { size: A5 landscape; margin: 10mm; }
        * { box-sizing: border-box; }
        body { font-family: 'Courier New', monospace; margin: 0; padding: 20px; color: #000; }
        .header { border-bottom: 3px solid #000; padding-bottom: 12px; margin-bottom: 16px; }
        .title { font-size: 26px; font-weight: 900; letter-spacing: 2px; margin: 0; }
        .subtitle { font-size: 12px; color: #444; margin-top: 4px; }
        .location-box { border: 3px solid #000; padding: 16px; text-align: center; margin: 16px 0; background: #f0f0f0; }
        .location-label { font-size: 11px; letter-spacing: 3px; margin-bottom: 6px; }
        .location-code { font-size: 42px; font-weight: 900; letter-spacing: 4px; }
        table { width: 100%; border-collapse: collapse; margin-top: 12px; }
        th, td { padding: 8px 12px; text-align: left; border-bottom: 1px solid #000; font-size: 14px; }
        th { background: #000; color: #fff; font-size: 11px; letter-spacing: 1px; }
        .qty-highlight { font-size: 22px; font-weight: 900; }
        .footer { margin-top: 24px; display: flex; justify-content: space-between; font-size: 11px; border-top: 2px solid #000; padding-top: 10px; }
        .signature { margin-top: 30px; }
        .sig-line { border-top: 1px solid #000; width: 200px; padding-top: 4px; font-size: 10px; }
        @media print { body { padding: 0; } .no-print { display: none; } }
      </style>
    </head>
    <body>
      <div class="header">
        <h1 class="title">${title}</h1>
        <div class="subtitle">Warehouse Management System • Printed: ${now}</div>
      </div>

      <div class="location-box">
        <div class="location-label">${locLabel}</div>
        <div class="location-code">${locCode || 'N/A'}</div>
      </div>

      <table>
        <tr><th>Item Code</th><td class="qty-highlight">${data.item_code || '-'}</td></tr>
        <tr><th>QC / Shade</th><td>${data.qc_number || '-'}</td></tr>
        <tr><th>Batch Number</th><td>${data.batch_number || '-'}</td></tr>
        <tr><th>Reference</th><td>${data.reference || '-'}</td></tr>
        ${data.date_in ? `<tr><th>Date In</th><td>${data.date_in}</td></tr>` : ''}
        <tr><th>Quantity</th><td class="qty-highlight">${data.pallets || data.quantity} plts${cartonInfo}</td></tr>
        ${data.suggestion_reason ? `<tr><th>Note</th><td>${data.suggestion_reason}</td></tr>` : ''}
      </table>

      <div class="signature">
        <div style="display: flex; gap: 40px;">
          <div class="sig-line">Forklift Driver Signature</div>
          <div class="sig-line">Warehouse Supervisor</div>
        </div>
      </div>

      <div class="footer">
        <span>Task ID: ${data.task_id || data.id || '-'}</span>
        <span>WMS © ${new Date().getFullYear()}</span>
      </div>

      <div class="no-print" style="margin-top: 20px; text-align: center;">
        <button onclick="window.print()" style="padding: 10px 24px; font-size: 14px; cursor: pointer;">Print Now</button>
        <button onclick="window.close()" style="padding: 10px 24px; font-size: 14px; margin-left: 10px; cursor: pointer;">Close</button>
      </div>
    </body>
    </html>
  `;

  const printWin = window.open('', '_blank', 'width=800,height=700');
  if (!printWin) {
    alert('Please allow pop-ups to print the movement slip');
    return;
  }
  printWin.document.write(html);
  printWin.document.close();
  setTimeout(() => { printWin.print(); }, 300);
}


export function printHousekeepingSlip(task) {
  const now = new Date().toLocaleString();
  const slipNo = task.slip_no || `HK-${(task.task_id || task.id || '').slice(0, 8).toUpperCase()}`;
  const priority = (task.priority || 'normal').toUpperCase();
  const lines = Array.isArray(task.movement_lines) ? task.movement_lines : [];
  const totalPlt = lines.reduce((s, l) => s + (l.pallets || 0), 0) || task.quantity || 0;
  const totalCtn = lines.reduce((s, l) => s + (l.cartons || 0) * (l.pallets || 1), 0);

  const linesRows = lines.length > 0 ? lines.map((ln, i) => `
    <tr>
      <td class="idx">${i + 1}</td>
      <td class="mono bold">${ln.item_code || '-'}</td>
      <td class="mono">${ln.qc_number || '-'}</td>
      <td class="mono">${ln.batch_number || '-'}</td>
      <td class="mono num">${ln.pallets || 0}</td>
      <td class="mono num">${ln.cartons || 0}</td>
    </tr>
  `).join('') : `
    <tr>
      <td class="idx">1</td>
      <td class="mono bold">${task.item_code || '-'}</td>
      <td class="mono">-</td>
      <td class="mono">-</td>
      <td class="mono num">${task.quantity || 0}</td>
      <td class="mono num">-</td>
    </tr>
  `;

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Housekeeping Instruction - ${slipNo}</title>
      <style>
        @page { size: A4 portrait; margin: 12mm; }
        * { box-sizing: border-box; }
        body { font-family: 'Helvetica', Arial, sans-serif; margin: 0; padding: 18px; color: #000; }
        .header { border-bottom: 3px solid #000; padding-bottom: 12px; margin-bottom: 14px; display: flex; justify-content: space-between; align-items: flex-start; }
        .title { font-size: 22px; font-weight: 900; letter-spacing: 1.5px; margin: 0; color: #7C3AED; }
        .subtitle { font-size: 10px; color: #444; margin-top: 4px; }
        .slip-box { border: 3px solid #000; padding: 8px 14px; text-align: center; background: #F5F3FF; }
        .slip-label { font-size: 9px; letter-spacing: 2px; margin: 0; }
        .slip-num { font-size: 18px; font-weight: 900; letter-spacing: 1px; margin: 2px 0 0; }
        .movement { display: flex; align-items: center; gap: 16px; margin: 18px 0; }
        .loc-box { flex: 1; border: 3px solid #000; padding: 14px; text-align: center; }
        .loc-box.from { border-color: #DC2626; background: #FEF2F2; }
        .loc-box.to { border-color: #16A34A; background: #F0FDF4; }
        .loc-label { font-size: 11px; letter-spacing: 3px; margin-bottom: 6px; font-weight: 700; }
        .loc-code { font-size: 28px; font-weight: 900; letter-spacing: 2px; font-family: 'Courier New', monospace; }
        .arrow { font-size: 30px; font-weight: 900; }
        .meta { display: flex; gap: 30px; padding: 8px 12px; background: #f8f8f8; border-left: 4px solid #000; margin-bottom: 12px; font-size: 11px; }
        .meta strong { font-size: 14px; }
        table.lines { width: 100%; border-collapse: collapse; margin-top: 6px; font-size: 11px; }
        table.lines th, table.lines td { padding: 8px 10px; border: 1px solid #666; text-align: left; }
        table.lines th { background: #000; color: #fff; font-size: 9px; text-transform: uppercase; letter-spacing: 1px; }
        table.lines .idx { text-align: center; width: 30px; }
        table.lines .num { text-align: right; font-weight: 700; }
        table.lines tfoot td { background: #f0f0f0; font-weight: 900; }
        .prio { display: inline-block; padding: 3px 10px; font-size: 10px; font-weight: 900; letter-spacing: 1px; border-radius: 2px; }
        .prio.HIGH { background: #DC2626; color: #fff; }
        .prio.MEDIUM { background: #F59E0B; color: #fff; }
        .prio.LOW, .prio.NORMAL { background: #52525B; color: #fff; }
        .signature { margin-top: 20px; display: flex; justify-content: space-between; gap: 30px; page-break-inside: avoid; }
        .sig { flex: 1; }
        .sig-line { border-top: 1px solid #000; margin-top: 30px; padding-top: 4px; font-size: 9px; }
        .footer { margin-top: 18px; display: flex; justify-content: space-between; font-size: 8px; color: #666; border-top: 1px solid #ccc; padding-top: 6px; }
        .mono { font-family: 'Courier New', monospace; }
        .bold { font-weight: 700; }
        @media print { body { padding: 0; } .no-print { display: none; } }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <h1 class="title">HOUSEKEEPING INSTRUCTION</h1>
          <div class="subtitle">Move selected stock to new location • Printed: ${now}</div>
        </div>
        <div class="slip-box">
          <p class="slip-label">SLIP NO</p>
          <p class="slip-num">${slipNo}</p>
        </div>
      </div>

      <div class="movement">
        <div class="loc-box from">
          <div class="loc-label">FROM</div>
          <div class="loc-code">${task.from_location_code || 'TBD'}</div>
        </div>
        <div class="arrow">→</div>
        <div class="loc-box to">
          <div class="loc-label">TO</div>
          <div class="loc-code">${task.to_location_code || 'TBD'}</div>
        </div>
      </div>

      <div class="meta">
        <span>Priority: <span class="prio ${priority}">${priority}</span></span>
        <span>Total Pallets: <strong>${totalPlt} plt</strong></span>
        ${totalCtn > 0 ? `<span>Total Cartons: <strong>${totalCtn} ctns</strong></span>` : ''}
        ${task.reason ? `<span style="flex:1;">Reason: <strong>${task.reason}</strong></span>` : ''}
      </div>

      <table class="lines">
        <thead>
          <tr>
            <th class="idx">#</th>
            <th>Item Code</th>
            <th>QC / Shade</th>
            <th>Batch</th>
            <th class="num">Pallets</th>
            <th class="num">Ctns / Plt</th>
          </tr>
        </thead>
        <tbody>${linesRows}</tbody>
        <tfoot>
          <tr>
            <td colspan="4">TOTAL</td>
            <td class="num mono">${totalPlt}</td>
            <td class="num mono">${totalCtn || '-'}</td>
          </tr>
        </tfoot>
      </table>

      <div class="signature">
        <div class="sig"><div class="sig-line">Assigned Worker (Name & Signature)</div></div>
        <div class="sig"><div class="sig-line">Warehouse Supervisor</div></div>
        <div class="sig"><div class="sig-line">Date & Time Completed</div></div>
      </div>

      <div class="footer">
        <span>Slip ${slipNo} • Housekeeping / Consolidation</span>
        <span>WMS © ${new Date().getFullYear()}</span>
      </div>

      <div class="no-print" style="margin-top: 16px; text-align: center;">
        <button onclick="window.print()" style="padding: 10px 24px; font-size: 14px; cursor: pointer;">Print Now</button>
        <button onclick="window.close()" style="padding: 10px 24px; font-size: 14px; margin-left: 10px; cursor: pointer;">Close</button>
      </div>
    </body>
    </html>
  `;

  const printWin = window.open('', '_blank', 'width=900,height=750');
  if (!printWin) {
    alert('Please allow pop-ups to print the housekeeping slip');
    return;
  }
  printWin.document.write(html);
  printWin.document.close();
  setTimeout(() => { printWin.print(); }, 300);
}
